import { createStyles, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';
import FsSubtitle from './FsSubtitle';

const FsSubtitleBold = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 600,
    },
  })
)((props: TypographyAllProps) => <FsSubtitle {...props} />);

export default FsSubtitleBold;
